import * as z from 'zod';
import { shipSchema } from '@ais-ui/utils';
import { MessageSendPostRequest } from '@ais-ui/api-spec/config';

export const sendMessageFormSchema = z.object({
  type: z.string(),
  sender: z.string(),
  receiver: shipSchema.nullable(),
  message: z.string(),
  pss: z.string(),
});
export type SendMessageFormValues = z.infer<typeof sendMessageFormSchema>;

export const convertSendMessageValuesToBackend = (
  data: SendMessageFormValues,
): MessageSendPostRequest => {
  return {
    addressed: data?.type === 'addressed' ? 1 : 0,
    text: data.message,
    routing: [data.pss],
    type: 'safety', // It sounds from TRB that send message is only for safety related reasons (no goographical notice)
    senderMmsi: data.sender,
    destination: {
      mmsi: data.receiver?.mmsi ? data.receiver.mmsi.toString() : '',
    },
    time: '',
  };
};
